import "./display-card-status.scss";

interface IDisplayCardStatusProps
{
    /** A helyes működés helyett kijelzendő szöveg, ha gond van. */
    warningText?: string;

    isPlaceholderData?: boolean;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function DisplayCardStatus(props: IDisplayCardStatusProps)
{
    return (<div className={_renderColorClassName(props.warningText)}>{_renderText(props.warningText, props.isPlaceholderData)}</div>);
}

/**
 * Error text-et vagy helyes működést jelző szöveget ad vissza.
 * @param text
 */
function _renderText(text?: string, isPlaceholderData?: boolean)
{
    if (isPlaceholderData) return "Még nincs adat.";
    return (text ? text : "Helyes működés");
}

/**
 * Meghatározza a szöveg színét.
 * @param warningMessage Ha van, akkor warning kártya lesz látható.
 * @returns
 */
function _renderColorClassName(warningText?: string)
{
    return (warningText ? "display-card-status warning-display-card-status" : "display-card-status success-display-card-status");
}
